"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackupMatrix = void 0;
const react_1 = __importStar(require("react"));
const BackupMatrix_styles_1 = require("./BackupMatrix.styles");
const getValueAllSelectedCells_1 = require("./components/Matrix/helpers/getValueAllSelectedCells");
const helpers_1 = require("../helpers");
const CursorProvider_1 = require("./components/CursorProvider/CursorProvider");
const Matrix_1 = require("./components/Matrix/Matrix");
const types_1 = require("./types");
exports.BackupMatrix = (0, helpers_1.createUIElement)('BackupMatrix', (_a, ref) => {
    var { className, disabled, isSelectMode = false, format = types_1.BACKUP_MATRIX_FORMAT.eu, maxValue, minValue = 0, value: currValue, onChange, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "disabled", "isSelectMode", "format", "maxValue", "minValue", "value", "onChange", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const [cursor, setCursor] = (0, react_1.useState)({
        event: types_1.CURSOR_EVENT.onMouseMove
    });
    const getDefaultCellsValue = (0, react_1.useCallback)(() => {
        return !isSelectMode ? (0, getValueAllSelectedCells_1.getValueAllSelectedCells)() : {};
    }, [isSelectMode]);
    const cellsCurrValue = (0, react_1.useMemo)(() => ((currValue === null || currValue === void 0 ? void 0 : currValue.cells) ? currValue.cells : getDefaultCellsValue()), [currValue === null || currValue === void 0 ? void 0 : currValue.cells, getDefaultCellsValue]);
    const timeCurrValue = (0, react_1.useMemo)(() => ((currValue === null || currValue === void 0 ? void 0 : currValue.time) ? currValue.time : 0), [currValue === null || currValue === void 0 ? void 0 : currValue.time]);
    const onDocumentCursorProviderMouseMoveHandler = (0, react_1.useCallback)((e) => {
        setCursor(Object.assign(Object.assign({}, cursor), { x: e.clientX, y: e.clientY }));
    }, [cursor]);
    const onCursorProviderMouseMoveHandler = (0, react_1.useCallback)((e) => {
        setCursor(Object.assign(Object.assign({}, cursor), { x: e.nativeEvent.clientX, y: e.nativeEvent.clientY }));
    }, [cursor]);
    const onDocumentCursorProviderMouseUpHandler = (0, react_1.useCallback)((e) => {
        setCursor(Object.assign(Object.assign({}, cursor), { x: e.clientX, y: e.clientY, event: types_1.CURSOR_EVENT.onMouseUp }));
        document.removeEventListener('mouseup', onDocumentCursorProviderMouseUpHandler, {
            capture: true
        });
        document.removeEventListener('mousemove', onDocumentCursorProviderMouseMoveHandler, {
            capture: true
        });
    }, [cursor, onDocumentCursorProviderMouseMoveHandler]);
    const onCursorProviderMouseUpHandler = (0, react_1.useCallback)((e) => {
        setCursor(Object.assign(Object.assign({}, cursor), { x: e.nativeEvent.clientX, y: e.nativeEvent.clientY, event: types_1.CURSOR_EVENT.onMouseUp }));
    }, [cursor]);
    const onCursorProviderMouseDownHandler = (0, react_1.useCallback)((e) => {
        setCursor(Object.assign(Object.assign({}, cursor), { x: e.nativeEvent.clientX, y: e.nativeEvent.clientY, event: types_1.CURSOR_EVENT.onMouseDown }));
        document.addEventListener('mouseup', onDocumentCursorProviderMouseUpHandler, {
            capture: true
        });
        document.addEventListener('mousemove', onDocumentCursorProviderMouseMoveHandler, {
            capture: true
        });
    }, [
        cursor,
        onDocumentCursorProviderMouseMoveHandler,
        onDocumentCursorProviderMouseUpHandler
    ]);
    const resetEvent = (0, react_1.useCallback)(() => {
        setCursor(Object.assign(Object.assign({}, cursor), { event: types_1.CURSOR_EVENT.onMouseMove }));
    }, [cursor]);
    const dataSelectorId = (0, react_1.useMemo)(() => rest['data-selector-id'] || 'backupmatrix', [rest]);
    return (react_1.default.createElement(BackupMatrix_styles_1.StyledBackupMatrix, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-BackupMatrix', className) }),
        react_1.default.createElement(BackupMatrix_styles_1.StyledBackupMatrixWrapper, null,
            react_1.default.createElement(CursorProvider_1.CursorProvider, { "data-selector-id": `${dataSelectorId}-cursor-provider`, onMouseMove: onCursorProviderMouseMoveHandler, onMouseDown: onCursorProviderMouseDownHandler, onMouseUp: onCursorProviderMouseUpHandler },
                react_1.default.createElement(Matrix_1.Matrix, { "data-selector-id": `${dataSelectorId}-matrix`, disabled: !!disabled, selectedCells: cellsCurrValue, time: timeCurrValue, onChange: onChange, isSelectMode: isSelectMode, format: format, maxValue: maxValue, minValue: minValue, cursor: cursor, resetEvent: resetEvent })))));
});
//# sourceMappingURL=BackupMatrix.js.map